import { render, staticRenderFns } from "./TableInfo.vue?vue&type=template&id=f4565442&scoped=true&"
import script from "./TableInfo.vue?vue&type=script&lang=js&"
export * from "./TableInfo.vue?vue&type=script&lang=js&"
import style0 from "./TableInfo.vue?vue&type=style&index=0&id=f4565442&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4565442",
  null
  
)

export default component.exports